import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const Mcp = (props: TIconProps): ReactElement => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.40942 13.653L15.6241 3.43861C17.0047 2.0579 19.2435 2.0579 20.6241 3.43861C22.0047 4.81932 22.0047 7.0579 20.6241 8.43861M20.6241 8.43861L12.9094 16.153M20.6241 8.43861C22.0047 7.0579 24.2435 7.0579 25.6241 8.43861C27.0047 9.81932 27.0047 12.0579 25.6241 13.4385L16.9185 22.1442C16.4304 22.6323 16.4304 23.4238 16.9185 23.9119L18.5344 25.5278"
      stroke="hsl(from hsl(0 0% 9%) h s 50%)"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.9094 11.1521L15.1947 18.8669C13.8141 20.2475 11.5754 20.2475 10.1948 18.8669C8.81415 17.4861 8.81415 15.2475 10.1948 13.8669L17.9094 6.15234"
      stroke="hsl(from hsl(0 0% 9%) h s 50%)"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
